/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { injectIntl, intlShape } from 'react-intl';
import { subHours } from 'date-fns';
import { Panel, Table } from 'react-bootstrap';
import RichLabel from 'loracoms/RichLabel';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import { compactFormat } from 'lorautils/DateTimeUtils';
import TablePager from 'loracoms/TablePager';
import LoadingTable from 'loracoms/LoadingTable';
import callAPI from '@/api/callAPI';

function switchColor(numb) {
  let color = '#67809f';
  if (numb < 5) {
    color = '#1e824c';
  } else if (numb < 10) {
    color = '#2574a9';
  } else if (numb < 20) {
    color = '#f4d03f';
  } else if (numb < 40) {
    color = '#ec644b';
  }
  return color;
}

const propTypes = {
  intl: intlShape.isRequired,
  nodeStatus: PropTypes.object.isRequired,
};

class Logs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      status: 'pending',
      nodeStatus: props.nodeStatus,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.node.channel');
    this.onChangeMark = this.onChangeMark.bind(this);
  }

  componentWillMount() {
    this.loadLogs(this.state.nodeStatus);
  }

  componentWillReceiveProps({ nodeStatus }) {
    if (!_.isEqual(nodeStatus, this.props.nodeStatus)) {
      this.setState({ nodeStatus });
      this.loadLogs(nodeStatus);
    }
  }

  onChangeMark(mark = '') {
    this.loadLogs(this.state.nodeStatus, mark);
  }

  loadLogs({ id } = this.state.nodeStatus, mark) {
    if (!id) return;
    this.setState({ status: 'pending' });
    callAPI({
      endpoint: '/tdmng/allots',
      query: {
        mark,
        node: id,
        sort: '-start',
        limit: 20,
      },
    }).then((res) => {
      const { list, more, mark: m } = res;
      const firstRecord = !mark;
      this.setState({ list: list || [], status: 'success', more, mark: m, firstRecord });
    }).catch(() => {});
  }

  render() {
    const {
      list,
      status,
      nodeStatus,
      mark = 0,
      more = false,
      firstRecord = false,
    } = this.state;

    const thead = (
      <thead>
        <tr>
          <th>{this.intlMsg.msg('channel')}</th>
          <th>{this.intlMsg.msg('network.tdm.gateway.add', '')}</th>
          <th>{this.intlMsg.msg('startat')}</th>
          <th>{this.intlMsg.msg('endat')}</th>
          <th>Aloha Up</th>
          <th>TDM Up</th>
          <th>{this.intlMsg.msg('alohapercent')}/%</th>
        </tr>
      </thead>
    );

    let table;
    if (status !== 'success') {
      const rows = Math.max(1, Math.min(10, list.length));
      table = (
        <LoadingTable
          cols={7}
          rows={rows}
          className="aisz-table-light"
          striped
          bordered
          responsive
        >
          {thead}
        </LoadingTable>
      );
    } else {
      table = (
        <Table className="aisz-table-light" striped>
          {thead}
          <tbody>
            {_.map(list, (l, idx) => {
              let tdmup;
              let alohaup;
              let share;
              if (l.memo) {
                try {
                  const memo = l.memo;
                  tdmup = memo.tdmup;
                  alohaup = memo.alohaup;
                  share = _.isNumber(tdmup) && _.isNumber(alohaup) && (alohaup + tdmup > 0) ?
                    Number(((alohaup / (alohaup + tdmup)) * 100).toFixed(2)) : 0;
                } catch (err) {
                  // err;
                }
              } else if (!idx && firstRecord) { // 最新一条历史记录显示节点状态的值
                const { counters = {} } = nodeStatus;
                tdmup = counters.tdmup;
                alohaup = counters.alohaup;
                share = _.isNumber(tdmup) && _.isNumber(alohaup) && (alohaup + tdmup > 0) ?
                    Number(((alohaup / (alohaup + tdmup)) * 100).toFixed(2)) : 0;
              }
              return (
                <tr key={idx}>
                  <td><RichLabel content={String(l.channel)} /></td>
                  <td>
                    {l.gw &&
                    <Link to={`/network/tdm/gateway/${l.gw}`}>
                      {normalizeDevEUI(l.gw)}
                    </Link>
                    }
                  </td>
                  <td>{l.start && compactFormat(subHours(l.start, 8))}</td>
                  <td>{l.end && compactFormat(subHours(l.end, 8))}</td>
                  <td>{alohaup}</td>
                  <td>{tdmup}</td>
                  <td>{!_.isNil(share) &&
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                      <i className="fa fa-circle" style={{ color: switchColor(share), fontSize: '0.9rem' }} />&nbsp;
                      {share}
                    </span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      );
    }
    return (
      <Panel
        bsStyle="aisz-white" header={this.intlMsg.msg('logs')}
      >
        {table}
        <div className="text-right">
          <TablePager
            status={status}
            mark={mark}
            more={more}
            onNext={this.onChangeMark}
            onPrev={this.onChangeMark}
          />
        </div>
      </Panel>
    );
  }
}

Logs.propTypes = propTypes;

export default injectIntl(Logs);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/NodeStatus/Logs.jsx